import { SelectionSetId } from './../../../enums/selection-set-id.enum';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { CoreService } from './../../../services/core.service';
import { FiltersOperator } from './../../../widgets/filters/api/filters-operator.api';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { UserService } from './../../../services/user.service';
import { HelpService } from './../../help/help.service';
import { Data, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { ForecastService } from '../forecast.service';
import { TableString } from 'src/app/models/table-string.model';
import { ActivityData, ActivityDataNew, GroupData } from './models/activity-data.model';
import DataSource, { Options } from 'devextreme/data/data_source';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { UtilsService } from 'src/app/services/utils.service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { firstValueFrom } from 'rxjs';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';

@Component({
    selector: 'app-activity',
    // standalone: true,
    // imports: [
    // 	CommonModule,
    // 	InfoHeaderModule,
    // 	InfoTableModule,
    // 	ActivityCreateActivityPopUpModule,
    // 	ActivityGroupFieldModule,
    // 	FiltersGroupModule,
    // 	BookmarkNewComponent,
    // 	DxChartModule,
    // 	DxDropDownButtonModule,
    // 	DxTextAreaModule,
    // 	DxRangeSelectorModule,
    // 	DxDataGridModule,
    // 	DevEpressCommonModule,
    // 	DxButtonModule,
    // 	DxPopupModule,
    // 	DxDateBoxModule,
    // 	DxAutocompleteModule,
    // ],
    templateUrl: './activity.component.html',
    styleUrls: ['./activity.component.scss'],
    standalone: false
})
export default class ActivityComponent implements OnInit, AfterViewInit {

	public activityListItemsGridColumns: { columnName: string; caption: string }[] = [];
	public activityListItemsGridData: any[] = [];

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.ForecastActivitiesGridData,
				selectionSetId: SelectionSetId.ForecastActivitiesGridDataFilters,
			}
		)
	);

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public activitiesGridColumns: { columnName: string; caption: string }[] = [];
	public activitiesGridData: any[] = [];
	private ActivityObjectId: number;

	// @ViewChildren("activityListNameSelectBox") activityListNameSelectBoxComponents: QueryList<DxSelectBoxComponent>;
	private activityListNameSelectBoxPaginated: boolean;
	@ViewChild("activityListNameSelectBox", { static: false })
	public set activityListNameSelectBoxComponent(component: DxSelectBoxComponent) {
		if (component && !this.activityListNameSelectBoxPaginated) {

			this.activityListNameSelectBoxPaginated = true;

			component.instance.getDataSource().paginate(true);
		}
	};
	public activityListSelectionData: TableString[];

	private forecastElementSelectBoxPaginated: boolean;
	@ViewChild("forecastElementSelectBox", { static: false })
	public set forecastElementSelectBoxComponent(component: DxSelectBoxComponent) {
		if (component && !this.forecastElementSelectBoxPaginated) {

			this.forecastElementSelectBoxPaginated = true;

			component.instance.getDataSource().paginate(true);
		}
	};
	public forecastElementSelectionData: TableString[];

	private userNameSelectBoxPaginated: boolean;
	@ViewChild("userNameSelectBox", { static: false })
	public set userNameSelectBoxComponent(component: DxSelectBoxComponent) {
		if (component && !this.userNameSelectBoxPaginated) {

			this.userNameSelectBoxPaginated = true;

			component.instance.getDataSource().paginate(true);
		}
	};
	public usersSelectionData: TableString[];

	public activitiesObjectClientIds: string[] = [];

	public activities: any[] = [];

	public selectedActivity: ActivityData;
	public selectedActivityDisplay: ActivityData;
	public selectedActivityTableData: { activityGeneralTableData: any[][], activityGroupsTableData: any[][] };
	public activityGroupsSelectionData: DataSource[];

	@ViewChild('allItemsGrid', { static: false })
	public allItemsGrid: DxDataGridComponent;

	@ViewChild('itemsListGrid', { static: false })
	public itemsListGrid: DxDataGridComponent;

	public showInfoPopup: boolean;
	public infoPopupMessage: string = "DEFAULT MESSAGE";

	private readonly _componentTitle = "Activity";
	private readonly _activityObjectClientIdQueryParamName = "activityObjectClientId";

	constructor(
		private titleService: Title,
		private location: Location,
		private router: Router,
		private notificationService: NotificationService,
		private forecastService: ForecastService,
		private helpService: HelpService,
		private userService: UserService,
		private coreService: CoreService,
		private fileExportService:FileExportService,

		private _activatedRoute: ActivatedRoute,
		private tableParamService: TableParameterService
	) { }

	async ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		const $this = this;

		this.initializeActivitiesObjectClientIds().then(
			(response) => {
				$this._activatedRoute.queryParamMap.subscribe(
					(queryParams) => {
						let activityObjectClientId = queryParams.get($this._activityObjectClientIdQueryParamName);

						if (!activityObjectClientId && $this.activitiesObjectClientIds.length > 0) {
							activityObjectClientId = $this.activitiesObjectClientIds[0];
						}

						console.log(`ngOnInit-> initializeActivitiesObjectClientIds - ${$this._activityObjectClientIdQueryParamName}:`, activityObjectClientId);

						$this.selectActivity(activityObjectClientId);
					}
				);

				$this.initializeAutocompleteDataSource(false, "");
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);

		this.GetSettingsData();
		this.initializeSelectionData();

		await this.initializeBookmarks();

		this.loadPageData();

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(selection) => {
				this.pageFiltersOperator.load(
					{
						showLoadingIndicator: true,
					}
				);

				this.initializeActivitiesGridData();
			}
		);
	}

	IsExportListEnable = false;
	GetSettingsData() {
	  this.fileExportService.WebSettings("EnableExportForecastActivitylist").subscribe(resultFilename => {
		this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
	  }, err => {
		console.log(err,"err");
	  });
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "columnMode",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	tableHeight = 500;
	switchTableHeight() {
		this.tableHeight = this.tableParamService.changeTableHeigh(this.tableHeight);
	}

	compactMode = false;
	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;



		let currentState = this.allItemsGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.allItemsGrid.instance.state(currentState);
	}

	compactModeItemsList = false;
	onToggleColumnsModeItemsList() {
		this.compactModeItemsList = !this.compactModeItemsList;



		let currentState = this.itemsListGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.itemsListGrid.instance.state(currentState);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	ngAfterViewInit() {

	}

	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			)
		];

		return routeData;
	}

	public initializeSelectionData() {
		console.log("initializeSelectionData");



		this.forecastService.getActivityListSelectionData().subscribe(
			(response) => {
				console.log("initializeSelectionData -> getActivityListSelectionData - response:", response);

				this.activityListSelectionData = response;
				console.log("initializeSelectionData -> activityListSelectionData - activityListSelectionData:", this.activityListSelectionData);



				if (this.selectedActivity && this.selectedActivityDisplay) {
					this.selectedActivity.ActivityListName = this.activityListSelectionData.find((tableString) => tableString.id === this.selectedActivity.ActivityItemListId);
					this.selectedActivityDisplay.ActivityListName = this.activityListSelectionData.find((tableString) => tableString.id === this.selectedActivityDisplay.ActivityItemListId);
				}
			},
			(error) => {
				console.error(error);

				this.notificationService.error(error);
			}
		);

		this.forecastService.getForecastElementSelectionData().subscribe(
			{
				next: (response) => {


					this.forecastElementSelectionData = response;

					if (this.selectedActivity && this.selectedActivityDisplay) {
						this.selectedActivity.ForecastElementName = this.forecastElementSelectionData.find((tableString) => tableString.id === this.selectedActivity.ForecastElementId);
						this.selectedActivityDisplay.ForecastElementName = this.forecastElementSelectionData.find((tableString) => tableString.id === this.selectedActivityDisplay.ForecastElementId);
					}
				},
				error: (error) => {


					this.notificationService.error(error);
				}
			}
		);

		this.userService.getUsersSelectionData().subscribe(
			(response) => {
				console.log("initializeSelectionData -> getUsersSelectionData - response:", response);

				this.usersSelectionData = response;

				if (this.selectedActivity && this.selectedActivityDisplay) {
					this.selectedActivity.UserName = this.usersSelectionData.find((tableString) => tableString.id === this.selectedActivity.ResponsibleUserId);
					this.selectedActivityDisplay.UserName = this.usersSelectionData.find((tableString) => tableString.id === this.selectedActivityDisplay.ResponsibleUserId);
				}
			},
			(error) => {
				console.error(error);

				this.notificationService.error(error);
			}
		);
	}

	public onActivityListSelectionDataItemClick(event) {
		console.log("onActivityListSelectionDataItemClick - event:", event);

		this.selectedActivityDisplay.ActivityItemListId = event.itemData.id;
	}

	public onForecastElementSelectionDataItemClick(event) {
		console.log("onForecastElementSelectionDataItemClick - event:", event);

		this.selectedActivityDisplay.ForecastElementId = event.itemData.id;
	}

	public onUsersSelectionDataItemClick(event) {
		console.log("onUsersSelectionDataItemClick - event:", event);

		this.selectedActivityDisplay.ResponsibleUserId = event.itemData.id;
	}

	public activitiesAutocompleteDataSource: string[] = [];

	public initializeAutocompleteDataSource(filterByValue: boolean, value: string) {
		let source = this.activitiesObjectClientIds.map((activityObjectClientId) => activityObjectClientId);



		this.activitiesAutocompleteDataSource = source;
	}

	public activityPopUpAction: "create" | "clone";

	public activityPopUpVisible: boolean;

	public onCreateNewActivityClicked() {
		console.log("onCreateNewActivityClicked");

		this.activityPopUpAction = "create";
		this.activityPopUpVisible = true;
	}

	public onCloneActivityClicked() {
		console.log("onCloneActivityClicked");

		this.activityPopUpAction = "clone";
		this.activityPopUpVisible = true;
	}

	public createActivity(event) {
		console.log("createActivity");

		const $this = this;

		this.forecastService.createActivity(event.primaryValue).subscribe(
			(response) => {
				console.log("createActivity -> createActivity - response:", response);

				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;

				if (response.success) {
					$this.activityPopUpVisible = false;

					$this.onActivitySuccessfullyCreated(event.primaryValue);
				} else {
				}
			},
			(error) => {
				console.error(error);

				// If it's a conflict.
				if (error.status === 409 && !error.error.success) {
					$this.showInfoPopup = true;
					$this.infoPopupMessage = error.error.message;
				} else {
					$this.notificationService.error(error);
				}
			}
		);
	}

	public cloneActivity(event) {
		console.log("cloneActivity");

		const $this = this;

		this.forecastService.cloneActivity(event.primaryValue, this.selectedActivity.ActivityObjectClientId).subscribe(
			(response) => {
				console.log("cloneActivity -> cloneActivity - response:", response);

				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;

				if (response.success) {
					$this.activityPopUpVisible = false;

					$this.onActivitySuccessfullyCreated(event.primaryValue);
				} else {
				}
			},
			(error) => {
				console.error(error);

				// If it's a conflict.
				if (error.status === 409 && !error.error.success) {
					$this.showInfoPopup = true;
					$this.infoPopupMessage = error.error.message;
				} else {
					$this.notificationService.error(error);
				}
			}
		);
	}

	public onPopUpPrimaryButtonClicked(event) {
		switch (this.activityPopUpAction) {
			case "create":

				this.createActivity(event);

				break;
			case "clone":

				this.cloneActivity(event);

				break;
		}
	}

	public onActivitySuccessfullyCreated(event) {
		console.log("onActivitySuccessfullyCreated - event:", event);

		this.selectActivity(event);

		this.initializeActivitiesObjectClientIds().then(
			(response) => {
				this.initializeAutocompleteDataSource(false, "");
			},
			(error) => {
				console.error(error);

				this.notificationService.error(error);
			}
		);

		this.pageFiltersOperator.applyFilters();
	}


	public data: ActivityDataNew;
	public dataGrp: GroupData;
	public onUploadClick() {
		this.selectedActivityDisplay.prepareForSave();
		const $this = this;
		$this.data = new ActivityDataNew();
		$this.data.GroupData = [];
		$this.data.ActivityObjectClientId = $this.selectedActivityDisplay.ActivityObjectClientId;
		$this.data.StartDateId = $this.selectedActivityDisplay.StartDateId;
		$this.data.EndDateId = $this.selectedActivityDisplay.EndDateId;
		$this.data.Quantity = $this.selectedActivityDisplay.Quantity;
		$this.data.Probability = $this.selectedActivityDisplay.Probability;
		$this.data.ActivityItemListId = $this.selectedActivityDisplay.ActivityItemListId;
		$this.data.Comment = $this.selectedActivityDisplay.Comment;
		$this.data.DeterminationDateId = $this.selectedActivityDisplay.DeterminationDateId;
		$this.data.ApplyToForecast = $this.selectedActivityDisplay.ApplyToForecast;
		$this.data.ForecastElementId = $this.selectedActivityDisplay.ForecastElementId;
		$this.data.ResponsibleUserId = $this.selectedActivityDisplay.ResponsibleUserId;
		$this.data.Probability2 = $this.selectedActivityDisplay.Probability2;
		$this.data.ActivityObjectId = $this.ActivityObjectId;

		for (let index = 0; index < $this.selectedActivityTableData.activityGroupsTableData.length; index++) {

			if ($this.selectedActivityTableData.activityGroupsTableData[index] != null &&
				$this.selectedActivityTableData.activityGroupsTableData[index][0] != null &&
				$this.selectedActivityTableData.activityGroupsTableData[index][0] != "") {
				$this.dataGrp = new GroupData();
				$this.dataGrp.KeyPair = $this.selectedActivityTableData.activityGroupsTableData[index][0];
				$this.dataGrp.ValuePair = $this.selectedActivityDisplay[$this.selectedActivityTableData.activityGroupsTableData[index][0]];
				$this.data.GroupData.push($this.dataGrp);
			}
		}
		this.forecastService.saveActivityNew($this.data,{showLoadingIndicator: true,}).subscribe(
			(response) => {
				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;

				if (response.success) {
					$this.selectActivity($this.selectedActivityDisplay.ActivityObjectClientId);
				} else {
				}
			},
			(error) => {
				console.error(error);

				$this.showInfoPopup = true;
				$this.infoPopupMessage = error.error.message;

				$this.notificationService.error(error);
			}
		);
	}

	public onProductChange(event) {
		console.log("onProductChange", event);

		this.selectActivity(event);
	}

	public onActivityListsGridActionItemClicked(item: any) {
		console.log("onActivityListsGridActionItemClicked - item:", item);

		const $this = this;

		this.router.navigate(
			["forecast/activity-list"],
			{
				queryParams:
				{
					activityItemListId: $this.selectedActivity.ActivityItemListId
					// activityItemListId: item.data.ActivityItemListId
				}
			}
		);
	}

	public onActivityGridActionItemClicked(item: any) {
		console.log("onActivityGridActionItemClicked - item:", item);

		this.selectActivity(item.data.ActivityObjectClientId);
	}

	public lowerFirstLetter(string: string): string {
		return string.charAt(0).toLowerCase() + string.slice(1);
	}

	public selectActivity(activityObjectClientId: string) {
		const $this = this;

		// TODO: This should probably be done after activity has been selected and loaded.
		this.forecastService.getActivityTableData(activityObjectClientId).subscribe(
			async (response) => {
				console.log("selectActivity -> getActivityTableData - response:", response);

				$this.selectedActivityTableData = response;

				$this.activityGroupsSelectionData = [];

				for (let a = 0; a < $this.selectedActivityTableData.activityGroupsTableData.length; a++) {
					const element = $this.selectedActivityTableData.activityGroupsTableData[a];

					const storeData = await $this.coreService.getValueListElementsBySettingName(`${element[0]}SelectionListId`).toPromise();

					if (storeData.length > 0) {
						const dataSource = new DataSource(
							{
								store: storeData,
								paginate: true
							}
						);

						$this.activityGroupsSelectionData.push(dataSource);
					} else {
						$this.activityGroupsSelectionData.push(null);
					}
				}







				console.log("selectActivity -> getActivityTableData ->[] getValueListElementsBySettingName - activityGroupsSelectionData:", $this.activityGroupsSelectionData);
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);

		//? Try to find activity in cached array of acitvities before sending a request.
		this.selectedActivity = this.activities.find((activity) => activity.activityObjectClientId === activityObjectClientId);

		if (this.selectedActivity) {
			const url = `forecast/activity?${$this._activityObjectClientIdQueryParamName}=${this.selectedActivity.ActivityObjectClientId}`;
			this.location.replaceState(url);

			this.selectedActivity.initialize();
			this.selectedActivity.ActivityListName = this.activityListSelectionData.find((tableString) => tableString.id === this.selectedActivity.ActivityItemListId);
			this.selectedActivity.ForecastElementName = this.forecastElementSelectionData.find((tableString) => tableString.id === this.selectedActivity.ForecastElementId);
			this.selectedActivity.UserName = this.usersSelectionData.find((tableString) => tableString.id === this.selectedActivity.ResponsibleUserId);

			this.selectedActivityDisplay = Object.assign(new ActivityData(), this.selectedActivity);

			console.log("selectedActivity:", this.selectedActivity);

			this.initializeActivityListItemsGridData();

			return;
		}

		this.forecastService.getActivity(activityObjectClientId).subscribe(
			(response) => {
				console.log("selectActivity -> getActivity - response:", response);
				this.ActivityObjectId = response["ActivityObjectId"];
				console.log("response -> ActivityObjectId:", response["ActivityObjectId"], this.ActivityObjectId);


				$this.selectedActivity = Object.assign(new ActivityData(), response);
				$this.selectedActivity.initialize();
				$this.selectedActivity.ActivityListName = $this.activityListSelectionData.find((tableString) => tableString.id === $this.selectedActivity.ActivityItemListId);
				$this.selectedActivity.ForecastElementName = $this.forecastElementSelectionData.find((tableString) => tableString.id === $this.selectedActivity.ForecastElementId);
				$this.selectedActivity.UserName = $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedActivity.ResponsibleUserId);

				$this.selectedActivityDisplay = Object.assign(new ActivityData(), $this.selectedActivity);

				const url = `forecast/activity?${$this._activityObjectClientIdQueryParamName}=${$this.selectedActivity.ActivityObjectClientId}`;
				$this.location.replaceState(url);



				$this.initializeActivityListItemsGridData();
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	private initializeActivities() {
		const observable$ = this.forecastService.getActivities();

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				console.log("initializeActivities - response:", response);

				$this.activities = response;

				if ($this.activities.length < 1) console.warn("Didn't receive any objects.");
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	private initializeActivitiesObjectClientIds() {
		const observable$ = this.forecastService.getActivitiesObjectClientIds();

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				console.log("initializeActivitiesObjectClientIds - response:", response);

				$this.activitiesObjectClientIds = response;

				if ($this.activitiesObjectClientIds.length < 1) console.warn("Didn't receive any objects ids, thus couldn't select a default object to display.");
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (response) => {

					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.initializeActivitiesGridData();
					}
				}
			}
		);
	}

	private initializeActivityListItemsGridData() {
		if (!this.selectedActivity.ActivityItemListId) {
			return undefined;
		}

		const observable$ = this.forecastService.getActivityListItemsGridData(this.selectedActivity.ActivityItemListId);

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				$this.activityListItemsGridColumns = response.columns;
				$this.activityListItemsGridData = response.data;
			}
		);
	}

	private initializeActivitiesGridData() {
		const observable$ = this.forecastService.getActivitiesGridData(
			this.pageFiltersOperator
		);

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				console.log("initializeActivitiesGridData -> getActivitiesGridData - response:", response);

				$this.activitiesGridColumns = response.columns;
				$this.activitiesGridData = response.data;
			}
		);
	}

	private removeActivitiesGridRow(data) {
		console.log("removeActivitiesGridRow - data:", data);

		const $this = this;

		this.forecastService.deleteActivity(data).subscribe(
			(response) => {
				if (response.success) {


					$this.initializeActivitiesObjectClientIds().then(
						(response) => {
							$this.initializeAutocompleteDataSource(false, "");

							if ($this.selectedActivity.ActivityObjectClientId === data.ActivityObjectClientId) {
								if ($this.activitiesObjectClientIds.length > 0){
									$this.selectActivity($this.activitiesObjectClientIds[0]);
								}
							}
						},
						(error) => {
							console.error(error);

							$this.notificationService.error(error);
						}
					);
				}
			}
		);
	}

	public onActivitiesGridRowRemoved(event) {
		console.log("onActivitiesListsGridRowRemoved - event:", event);

		this.removeActivitiesGridRow(event.data);
	}

	// <Toggles>

	public activityDetailsToggleValue: boolean = true;
	public onActivityDetailsToggleClicked(event: boolean) {
		console.log("onActivityDetailsToggleClicked - event:", event);

		this.activityDetailsToggleValue = event;
	}

	public activityItemsListToggleValue: boolean = true;
	public onActivityItemsListToggleClicked(event: boolean) {
		console.log("onActivityItemsListToggleClicked - event:", event);

		this.activityItemsListToggleValue = event;
	}

	public toggleInfoPopupStatus() {
		this.showInfoPopup = !this.showInfoPopup;
	}

	// </Toggles>

	public onHelpButtonClicked(event, settingName: string) {
		console.log("onHelpButtonClicked - event:", event);

		this.helpService.openHelpPage(settingName);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReadyItemsList(evt) {
		//creating new data source
		let gridData = new DataSource(
			<Options>
			{
				store: this.itemsListGrid.dataSource,
				paginate: false
			}
		);

		//Getting all Filtering
		let filterExpr = evt.component.getCombinedFilter();
		if (filterExpr != null) {
			gridData.filter(filterExpr);
		}

		//Getting all sorting
		let sortingExpres = evt.component.getDataSource().sort();
		if (sortingExpres != null) {
			gridData.sort(sortingExpres);
		}

		gridData.load().then((result) => {
        	this.activitiesAutocompleteDataSource = result.map(item => item.ActivityObjectClientId).filter(id => id != null && id !== '');
		});
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-activity-items-list', JSON.stringify(this.itemsListGrid.instance.state()));
	}

	public dxDataGridOperatorItemsList: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperatorItemsList.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-activity-all', JSON.stringify(this.allItemsGrid.instance.state()));
	}
}
